import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <title>页面不存在 | 深夜爆料</title>
      <meta name="robots" content="noindex, follow" />
      <div className="pt-16">
        <section className="ink-panel relative flex min-h-[70vh] items-center overflow-hidden">
          <div className="grid-rule absolute inset-0 opacity-30" />
          <div className="wrap relative py-20">
            <span className="font-heading text-[6rem] font-black leading-none text-primary-500/70 md:text-[10rem]">
              404
            </span>
            <h1 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-4xl">
              这条巷子走不通
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              你访问的页面不存在，或者它已经被合并到其他线索条目里。以下入口可以带你回到有内容的地方。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="btn-base bg-primary-500 px-6 py-3 text-background-50 hover:bg-primary-600"
              >
                <i className="ri-home-4-line text-base" />
                回到首页
              </Link>
              <Link
                to="/leaks"
                className="btn-base border border-background-50/25 px-6 py-3 text-background-50 hover:bg-background-50/10"
              >
                <i className="ri-folder-open-line text-base" />
                浏览线索库
              </Link>
              <Link
                to="/about"
                className="btn-base border border-background-50/25 px-6 py-3 text-background-50 hover:bg-background-50/10"
              >
                <i className="ri-information-line text-base" />
                关于本站
              </Link>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}